import * as TemplateActions from "./TemplateActions.js";
import * as TemplateQueries from "../../../graphql/queries/template-queries";
import {
  graphQLClient,
  executeGraphQLRequest,
  createContext,
} from "../../../graphql/graphql-client";
import { SanitizeTemplateInput } from "../../models/TemplateModel.js";
import { SanitizeTemplateParameterInput } from "../../models/TemplateParameterItemInputModel";
import {
  getSignedUrl,
  removeS3File,
  uploadFileToS3,
} from "../../helpers/S3Helpers.js";
import { getFileExtension, randomString } from "../../helpers/StringHelpers.js";
import { RESOURCE_TYPES } from "../../constants/AppEnums.js";
import { GET_SIGNED_URL_PATH } from "../../constants/ApiConstants.js";
import axios from "axios";

export const fetchTemplates = (filter, from, size) => {
  console.log("Fetching templates...");

  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.fetchTemplatesBegin,
        success: TemplateActions.fetchTemplatesSuccess,
        failure: TemplateActions.fetchTemplatesFailure
      },
      TemplateQueries.GET_TEMPLATES_BY_FILTER_QUERY,
      {
        filter: filter,
        from: from,
        size: size,
        context: createContext(user_id, "LIST", "TEMPLATE"),
      }
    );
  };
};

export const cloneTemplate = ({ user, templateId, templateTitle, access }) => {
  console.log("Cloning template...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.cloneTemplateBegin,
        success: TemplateActions.cloneTemplateSuccess,
        failure: TemplateActions.cloneTemplateFailure,
      },
      TemplateQueries.CLONE_TEMPLATE_MUTATION,
      {
        input: {
          id: templateId,
          title: templateTitle,
          access: access,
        },
        context: createContext(user_id, "CLONE", "TEMPLATE", templateId),
      }
    );
  };
};
export const fetchTemplateById = (templateId) => {
  console.log("Fetching template by id...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.fetchActiveTemplateBegin,
        success: TemplateActions.fetchActiveTemplateSuccess,
        failure: TemplateActions.fetchActiveTemplateFailure,
      },
      TemplateQueries.GET_TEMPLATE_BY_ID_QUERY,
      {
        id: {primaryId: templateId},
        context: createContext(user_id, "READ", "TEMPLATE", templateId),
      }
    );
  };
};

export const deleteTemplate = (templateId) => {
  console.log("Deleting template...");
  return (dispatch, getState) => {
    const state = getState();
    const user_id = state.user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.deleteTemplateBegin,
        success: TemplateActions.deleteTemplateSuccess,
        failure: TemplateActions.deleteTemplateFailure,
      },
      TemplateQueries.DELETE_TEMPLATE_MUTATION,
      {
        id: {primaryId: templateId},
        context: createContext(user_id, "DELETE", "TEMPLATE", templateId),
      }
    );
  };
};


export const deleteParameterGroup = (groupId) => {
  console.log("Deleting parameter group...");
  return (dispatch, getState) => {
    let templateId = getState().template.activeTemplate.id;
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.deleteParametersGroupBegin,
        success: TemplateActions.deleteParametersGroupSuccess,
        failure: TemplateActions.deleteParametersGroupFailure,
      },
      TemplateQueries.DELETE_PARAMETER_GROUP_MUTATION,
      {
        input: {primaryId: templateId, secondaryId: groupId},
        context: createContext(user_id, "DELETE", "TEMPLATE", templateId),
      }
    );
  };
};
const mapTemplateStateToGql = (template) => {
  return {
    description: template.description,
    title: template.title,
    solver: template.solver,
    modelerTitle: template.modelerTitle,
    modelerDescription: template.modelerDescription,
    modelerAccess: template.modelerAccess,
    topics: template.topics,
    industries: template.industries,

  };
};

export const updateAndPublishTemplate = (templateId) => {
  return async (dispatch, getState) => {
    try {
      await dispatch(updateActiveTemplate());
      await dispatch(publishTemplate(templateId));
    } catch (error) {
      console.error("Failed to update and publish template:", error);
    }
  };
};


export const publishTemplate = (templateId) => {
  console.log("Publishing template...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    return executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.publishTemplateBegin,
        success: TemplateActions.publishTemplateSuccess,
        failure: TemplateActions.publishTemplateFailure,
      },
      TemplateQueries.PUBLISH_TEMPLATE_MUTATION,
      {
        input: {
          id: templateId,
        },
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
};

export const unpublishTemplate = (templateId) => {
  console.log("UnPublishing template...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.unpublishTemplateBegin,
        success: TemplateActions.unpublishTemplateSuccess,
        failure: TemplateActions.unpublishTemplateFailure,
      },
      TemplateQueries.UNPUBLISH_TEMPLATE_MUTATION,
      {
        input: {
          id: templateId,
        },
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
};

export const updateActiveTemplate = () => {
  console.log("Updating template...");
  return (dispatch, getState) => {
    const state = getState();
    const template = mapTemplateStateToGql(state.template.activeTemplate);
    const user_id = state.user.userId;
    const templatedId = state.template.activeTemplate.id;
    return executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.updateTemplateBegin,
        success: TemplateActions.updateTemplateSuccess,
        failure: TemplateActions.updateTemplateFailure,
      },
      TemplateQueries.UPDATE_TEMPLATE_MUTATION,
      {
        input: template,
        condition: {primaryId: templatedId},
        context: createContext(user_id, "UPDATE", "TEMPLATE", templatedId),
      }
    );
  };
};

export const createNewTemplate = (template) => {
  console.log("Creating new template...");
  return (dispatch, getState) => {
    const state = getState();
    template["owner"] = state.user.primaryOrgId;
    let sanitizedTemplate = SanitizeTemplateInput(template);
    const user_id = state.user.userId;

    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.createNewTemplateBegin,
        success: TemplateActions.createNewTemplateSuccess,
        failure: TemplateActions.createNewTemplateFailure,
      },
      TemplateQueries.CREATE_NEW_TEMPLATE_MUTATION,
      {
        input: sanitizedTemplate,
        context: createContext(user_id, "CREATE", "TEMPLATE"),
      }
    );
  };
};
export const createParameterGroup = (templateId, groupName) => {
  console.log("Creating parameter group...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.createParameterGroupBegin,
        success: TemplateActions.createParameterGroupSuccess,
        failure: TemplateActions.createParameterGroupFailure,
      },
      TemplateQueries.CREATE_PARAMETER_GROUP_MUTATION,
      {
        input: { templateId: templateId, name: groupName},
        context: createContext(user_id, "CREATE", "TEMPLATE", templateId, "PARAMETERGROUP"),
      }
    );
  };
};
export const createParameterItem = (groupId, parameterItem) => {
  console.log("Creating parameter item...");
  return (dispatch, getState) => {
    let templateId = getState().template.activeTemplate.id;
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.createTemplateParameterItemBegin,
        success: TemplateActions.createTemplateParameterItemSuccess,
        failure: TemplateActions.createTemplateParameterItemFailure,
      },
      TemplateQueries.CREATE_PARAMETER_ITEM_MUTATION,
      {
        input: { templateId: templateId,  groupId: groupId, ...parameterItem },
        context: createContext(user_id, "CREATE", "TEMPLATE", templateId, "PARAMETERITEM"),
      }
    );
  };
};
export const deleteParameterItem = (parameterId) => {
  console.log("Deleting parameter item...");
  return (dispatch, getState) => {
    let templateId = getState().template.activeTemplate.id;
    const groupId = getState().template.activeTemplate.selectedGroup.id;
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.deleteTemplateParameterItemBegin,
        success: TemplateActions.deleteTemplateParameterItemSuccess,
        failure: TemplateActions.deleteTemplateParameterItemFailure,
      },
      TemplateQueries.DELETE_PARAMETER_ITEM_MUTATION,
      {
        id: {primaryId: templateId, secondaryId: groupId, tertiaryId: parameterId},
        context: createContext(user_id, "DELETE", "TEMPLATE", templateId),
      }
    );
  };
};

export const updateParameterGroup = (group) => {
  console.log("Updating parameter group...");
  let updateGroup = {name: group.name}
  return (dispatch, getState) => {
    let templateId = getState().template.activeTemplate.id;
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.updateTemplateParameterGroupBegin,
        success: TemplateActions.updateTemplateParameterGroupSuccess,
        failure: TemplateActions.updateTemplateParameterGroupFailure,
      },
      TemplateQueries.UPDATE_PARAMETER_GROUP_MUTATION,
      {
        input: updateGroup,
        condition: {primaryId: templateId, secondaryId: group.id},
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
};



export const updateParameterItem = (parameterItem) => {
  console.log("Updating parameter item...");
  return (dispatch, getState) => {
    let templateId = getState().template.activeTemplate.id;
    const user_id = getState().user.userId;
    const groupId = getState().template.activeTemplate.selectedGroup.id;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.updateTemplateParameterItemBegin,
        success: TemplateActions.updateTemplateParameterItemSuccess,
        failure: TemplateActions.updateTemplateParameterItemFailure,
      },
      TemplateQueries.UPDATE_PARAMETER_ITEM_MUTATION,
      {
        input: SanitizeTemplateParameterInput(parameterItem),
        condition: {primaryId: templateId, secondaryId: groupId, tertiaryId: parameterItem.id},
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
};

export const createTemplateFolder = (node, folder) => {
  console.log("Creating template folder...");
  return (dispatch, getState) => {
    const state = getState();
    const user_id = state.user.userId;
    let { isEditing, ...addingFolder } = folder;
    addingFolder["templateId"] = state.template.activeTemplate.id;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.createTemplateFolderBegin,
        success: TemplateActions.createTemplateFolderSuccess,         
        failure: null, // Handle failure if you need
      },
      TemplateQueries.CREATE_FOLDER_ITEM_MUTATION,
      {
        folder: addingFolder,
        context: createContext(
          user_id,
          "CREATE",
          "TEMPLATE",
          state.template.activeTemplate.id,
          "FOLDERITEM",
        ),
      }
    );
  };
};
//TODO: This functionality should be moved to the backend
export const deleteTemplateFolder = (folderId) => {
  console.log("Deleting template folder...");
  return (dispatch, getState) => {
    const state = getState();
    const user_id = state.user.userId;
    const templateId = state.template.activeTemplate.id;
    dispatch(TemplateActions.deleteTemplateFolderBegin(folderId));

    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: null, // We already dispatched it above
        success: TemplateActions.deleteTemplateFolderSuccess,
        failure: TemplateActions.deleteTemplateFolderFailure // Handle failure if you need
      },
      TemplateQueries.DELETE_FOLDER_ITEM_MUTATION,
      {
        id: {primaryId: templateId, secondaryId: folderId},
        context: createContext(user_id, "DELETE", "TEMPLATE", templateId),
      }
    );
  };
};

export const renameFolderItem = (folderId, newName) => {
  console.log("Renaming template folder...");
  return (dispatch, getState) => {
    const templateId = getState().template.activeTemplate.id;
    const user_id = getState().user.userId;
    dispatch(TemplateActions.updateTemplateFolderBegin({ folderId, newName }));

    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: null, // We already dispatched it above
        success: TemplateActions.updateTemplateFolderSuccess,
        failure: TemplateActions.updateFolderItemFailure, // Handle failure if you need
      },
      TemplateQueries.UPDATE_FOLDER_ITEM_MUTATION,
      {
        folder: {
          name: newName,
        },
        condition: {primaryId: templateId, secondaryId: folderId},
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
};

export const uploadTemplateThumbnailImage = (imageFile) => {
  console.log("Uploading template thumbnail image...");
  return async (dispatch, getState) => {
    const state = getState();
    const { id, thumbnailImage: imageName } = state.template.activeTemplate;
    const resourcePath = `${id}/${imageName}`;

    try {
      await uploadFileToS3(RESOURCE_TYPES.TEMPLATE, resourcePath, imageFile);
      console.log("File uploaded successfully");

      try {
        const s3url = await getSignedUrl(
          GET_SIGNED_URL_PATH,
          RESOURCE_TYPES.TEMPLATE,
          resourcePath
        );
        dispatch(TemplateActions.updateTemplateThumbnailImage({ imageUrl: s3url }));
      } catch (error) {
        console.log("Error getting signed URL:", error);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
};

export const uploadTemplateModelerThumbnailImage = (imageFile) => {
  console.log("Uploading template modeler thumbnail image...");
  return async (dispatch, getState) => {
    const state = getState();
    const { id, modelerThumbnailImage: imageName } =
      state.template.activeTemplate;
    const resourcePath = `${id}/${imageName}`;

    try {
      await uploadFileToS3(RESOURCE_TYPES.TEMPLATE, resourcePath, imageFile);
      console.log("File uploaded successfully");

      try {
        const s3url = await getSignedUrl(
          GET_SIGNED_URL_PATH,
          RESOURCE_TYPES.TEMPLATE,
          resourcePath
        );
        dispatch(TemplateActions.updateTemplateModelerThumbnailImage({ imageUrl: s3url }));
      } catch (error) {
        console.log("Error getting signed URL:", error);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
};

export const fetchFileContent = (templateId, folderItemId) => {
  console.log("Fetching file content...");
  return async (dispatch, getState) => {
    const state = getState();
    const user_id = state.user.userId;

    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.fetchFileContentBegin,
        success: TemplateActions.fetchFileContentSuccess,
        failure: TemplateActions.fetchFileContentFailure,
      },
      TemplateQueries.GET_FILE_CONTENT_QUERY,
      {
        id: {primaryId: templateId, secondaryId: folderItemId, tertiaryId: "1"},
        context: createContext(user_id, "READ", "TEMPLATE", templateId),
      }
    );
 };
}

export const updateFileContent = (templateId, folderItemId, content) => {
  console.log("Updating file content...");
  return async (dispatch, getState) => {
    const state = getState();
    const user_id = state.user.userId;

    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.updateFileContentBegin,
        success: TemplateActions.updateFileContentSuccess,
        failure: TemplateActions.updateFileContentFailure,
      },
      TemplateQueries.UPDATE_FILE_CONTENT_MUTATION,
      {
        input: {
          content: content,
        },
        condition: {
          primaryId: templateId,
          secondaryId: folderItemId,
          tertiaryId: "1",          
        },
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
};

export const uploadTemplateObjFile = (filename, objFile) => { 
  console.log("Uploading template obj file...");
  return async (dispatch, getState) => {
    const state = getState();
    const template = state.template.activeTemplate;
    const user_id = getState().user.userId;
    const resourcePath = `${template?.id}/${filename}`;
    const cancelTokenSource = axios.CancelToken.source();
    dispatch(
      TemplateActions.addObjectFileUploadCancelToken(
        filename,
        cancelTokenSource.cancel
      )
    ); // Store the cancel function in the state
    uploadFileToS3(
      RESOURCE_TYPES.TEMPLATE,
      resourcePath,
      objFile,
      null,
      (progress) => {
        dispatch({
          type: "SET_OBEJCT_FILE_UPLOAD_PROGRESS_ACTION", 
          filename: filename,
          progress,
        });
      },
      (res) => {
       
      },
      (error) => {
        console.error("Error during upload:", error);
        dispatch(TemplateActions.removeObjectFileUploadCancelToken(filename));
        // You can dispatch other actions here to inform the user about the error if needed.
      },
      cancelTokenSource.token // Pass the cancel token source to the upload function
    );
  };
}

export const cancelUploadTemplateObjFile = (filename) => {
  console.log("Cancelling template obj file upload...");
  return async (dispatch, getState) => {
    const state = getState();
    let cancelToken = state.template.cancelTokens?.[filename] ?? null;
    if(cancelToken) {
      cancelToken("Cancelled by user");
      dispatch(TemplateActions.removeObjectFileUploadCancelToken(filename));
    }
  };
}

export const publishProduct = (templateId, sellDetails) => {
  console.log("Publishing product...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.publishProductBegin,
        success: TemplateActions.publishProductSuccess,
        failure: TemplateActions.publishProductFailure,
      },
      TemplateQueries.PUBLISH_PRODUCT_MUTATION,
      {
        input: {
          templateId: templateId,
          includeTemplate: sellDetails.includeTemplate,
          includeModeler: sellDetails.includeModeler,
          price: sellDetails.price,
        },
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
}

export const unpublishProduct = (templateId) => {
  console.log("UnPublishing product...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.unpublishProductBegin,
        success: TemplateActions.unpublishProductSuccess,
        failure: TemplateActions.unpublishProductFailure,
      },
      TemplateQueries.UNPUBLISH_PRODUCT_MUTATION,
      {
        input: {
          templateId: templateId,
        },
        context: createContext(user_id, "UPDATE", "TEMPLATE", templateId),
      }
    );
  };
}

export const updateTemplateAndPublishProduct = (templateId, sellDetails) => {
  return async (dispatch, getState) => {
    try {
      await dispatch(updateActiveTemplate());
      await dispatch(publishProduct(templateId, sellDetails));
    } catch (error) {
      console.error("Failed to update and publish product:", error);
    }
  };
}


export const fetchProducts = (filter) => {
  console.log("Fetching products...");
  return (dispatch, getState) => {
    const user_id = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: TemplateActions.fetchProductsBegin,
        success: TemplateActions.fetchProductsSuccess,
        failure: TemplateActions.fetchProductsFailure,
      },
      TemplateQueries.GET_PRODUCTS_BY_FILTER_QUERY,
      {
        filter: filter,
        from: 0,
        size: 10,
        context: createContext(user_id, "LIST", "TEMPLATE"),
      }
    );
  };
}